import React from 'react'
import { Modal, ModalBody } from 'uiComponents/popups/modal.new'
import { OptionTile } from 'uiComponents/optionTile'
import { LucideIconName } from 'utils/lucideIcon'
import { UserRole } from 'settings/schema'
import './chooseUserRoleModal.scss'

interface UserRoleDetails {
    title: string
    description: string
    icon: LucideIconName
}

const useRoleDetails: Record<UserRole, UserRoleDetails> = {
    user: {
        title: 'Regular user',
        description: 'Add a regular user with specific permissions',
        icon: 'UserRound',
    },
    admin: {
        title: 'Admin',
        description: 'Add an admin user with full access',
        icon: 'ShieldUser',
    },
    reseller: {
        title: 'Reseller',
        description: 'Add a user for one of your resellers',
        icon: 'Store',
    },
    staff: {
        title: 'Convious admin',
        description: 'Add a Convious admin with full access to all partner accounts',
        icon: 'GlobeLock',
    },
}

interface ChooseUserRoleModalProps {
    options: UserRole[]
    onSelectUserRole: (userRole: UserRole) => void
    onDismiss: () => void
}

export const ChooseUserRoleModal = ({ options, onSelectUserRole, onDismiss }: ChooseUserRoleModalProps) => (
    <Modal title="Choose user role" className="choose-user-role-modal" onDismiss={onDismiss}>
        <ModalBody>
            {options.map((option) => (
                <OptionTile
                    key={option}
                    title={useRoleDetails[option].title}
                    description={useRoleDetails[option].description}
                    icon={useRoleDetails[option].icon}
                    className={option}
                    onClick={() => onSelectUserRole(option)}
                />
            ))}
        </ModalBody>
    </Modal>
)
